import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import { Button } from "@/components/ui/button";
import { HomeIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import { NotFoundSchema } from '@/components/seo/404Schema';
import SEO from '@/components/SEO';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  const suggestedPages = [
    { name: "For Older Adults", path: "/older-adults" },
    { name: "For Families", path: "/thrivefamily" },
    { name: "For Caregivers", path: "/caregivers" },
    { name: "Features", path: "/features" },
    { name: "Pricing", path: "/pricing" },
    { name: "Support", path: "/support" }
  ];

  return (
    <>
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist or has been moved." noindex />
      <Helmet>
        <meta name="render:status_code" content="404" />
        <meta name="prerender-status-code" content="404" />
      </Helmet>
      <NotFoundSchema requestedUrl={location.pathname} />
      <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <div className="mb-8">
          <h1 className="text-8xl font-bold text-muted-foreground/30 mb-4">404</h1>
          <h2 className="text-2xl font-bold text-foreground mb-4">Page Not Found</h2>
          <p className="text-muted-foreground mb-8">
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="space-y-4 mb-8">
          <Button size="lg" className="w-full" asChild>
            <Link to="/">
              <HomeIcon className="w-5 h-5 mr-2" />
              Return to Home
            </Link>
          </Button>
          
          <Button variant="outline" size="lg" className="w-full" onClick={() => window.history.back()}>
            <ArrowLeftIcon className="w-5 h-5 mr-2" />
            Go Back
          </Button>
        </div>

        <div className="text-sm">
          <p className="text-muted-foreground mb-4">Or explore these popular pages:</p>
          <div className="grid grid-cols-2 gap-2">
            {suggestedPages.map((page) => (
              <Link
                key={page.path}
                to={page.path}
                className="text-primary hover:text-primary/80 hover:underline text-xs"
              >
                {page.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default NotFound;
